import { ProductSuggestionsSearchParams } from '@diamond/shared/types';
import {
  getProductCategories,
  getProductList,
  getProductSuggestions,
} from '@diamond/sol-buyer-context';
import { QueryClient } from '@tanstack/react-query';
import cleanDeep from 'clean-deep';

import { getProductFilters } from './filters';

export async function prefetchBrowseProduct(
  token: string,
  warehouse: string,
  page: number,
  size: number,
  query: Record<string, string | string[] | undefined>,
  productId = ''
) {
  const queryClient = new QueryClient();

  const filters = cleanDeep({
    ...getProductFilters(query),
    warehouse,
    size,
  });

  const categoryParams = cleanDeep({
    divisi_code: filters.divisi_code,
    storage_code: filters.storage_code,
    search_query: filters.search_query,
    product_id_substitute: filters.product_id,
    warehouse,
  });

  const promises: Array<Promise<void>> = [
    queryClient.prefetchQuery({
      queryKey: ['ProductCategory', page, '', categoryParams],
      queryFn: () =>
        getProductCategories(token, { ...categoryParams, page, size }),
    }),
  ];

  if (productId) {
    promises.push(
      queryClient.prefetchQuery({
        queryKey: [
          `ProductDataSuggestion-${filters.product_id}`,
          page,
          '',
          filters,
        ],
        queryFn: () =>
          getProductSuggestions(
            token,
            productId,
            filters as ProductSuggestionsSearchParams
          ).then((res) => res.data),
      })
    );
  } else {
    promises.push(
      queryClient.prefetchQuery({
        queryKey: ['ProductData', page, '', filters],
        queryFn: () => getProductList(token, filters),
      })
    );
  }

  // Prefetch data on the server
  await Promise.all(promises);

  return queryClient;
}
